import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { convertLegacyAppRoot } from '@backstage/core-compat-api';
import { FlatRoutes } from '@backstage/core-app-api';
import { Route } from 'react-router';
import { CatalogImportPage } from '@backstage/plugin-catalog-import';

import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import entityFeedbackPlugin from '@backstage-community/plugin-entity-feedback/alpha';
import ga4Module from '@backstage-community/plugin-analytics-module-ga4/alpha';
import { techDocsReportIssueAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import idpControlBasePlugin from '@internal/backstage-plugin-idp-control-base';

import { appModuleNav } from './modules/appModuleNav';
import { authModule } from './modules/authModule';
import { themeModule } from './modules/themeModule';
import { apiModule } from './modules/apiModule';
import { entityContentModule } from './modules/entityContentModule';
import { HomePage } from './components/home/HomePage';
import './styles.css';

// Custom HomePage layout module - renders the original card-based homepage
const customHomePageModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    HomePageLayoutBlueprint.make({
      params: {
        loader: async () =>
          function CustomHomePageLayout() {
            return <HomePage />;
          },
      },
    }),
  ],
});

// Legacy plugins that don't have alpha exports yet
const collectedLegacyPlugins = convertLegacyAppRoot(
  <FlatRoutes>
    <Route path="/catalog-import" element={<CatalogImportPage />} />
  </FlatRoutes>,
);

const app = createApp({
  features: [
    homePlugin,
    catalogPlugin,
    techdocsPlugin,
    scaffolderPlugin,
    apiDocsPlugin,
    searchPlugin,
    userSettingsPlugin,
    catalogGraphPlugin,
    notificationsPlugin,
    signalsPlugin,
    orgPlugin,
    kubernetesPlugin,
    entityFeedbackPlugin,
    ga4Module,
    techDocsReportIssueAddonModule,
    techDocsMermaidAddonModule,
    idpControlBasePlugin,
    appModuleNav,
    authModule,
    themeModule,
    apiModule,
    entityContentModule,
    customHomePageModule,
    ...collectedLegacyPlugins,
  ],
});

export default app.createRoot();
